import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.cdp.cof";
export interface PerceptionSignals {
    scannedCategoryIds: string[];
}
function createBasePerceptionSignals(): PerceptionSignals {
    return { scannedCategoryIds: [] };
}
export const PerceptionSignals: MessageFns<PerceptionSignals> = {
    encode(message: PerceptionSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        for (const v of message.scannedCategoryIds) {
            writer.uint32(10).string(v!);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): PerceptionSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePerceptionSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.scannedCategoryIds.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<PerceptionSignals>, I>>(base?: I): PerceptionSignals {
        return PerceptionSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<PerceptionSignals>, I>>(object: I): PerceptionSignals {
        const message = createBasePerceptionSignals();
        message.scannedCategoryIds = object.scannedCategoryIds?.map((e) => e) || [];
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
